import "./css/Modal.css";

import { Box } from "@mui/material";
import { ComponentChild, ComponentChildren, Fragment } from "preact";

import { ImageButton } from "./ImageButton";
import { TextButton } from "./TextButton";
import { disableInput } from "./Utility";

type SelectionOption = {
  text?: string;
  image?: string;
  button?: ComponentChild;
  onClicked?: () => void;
};

type ModalProps = {
  shown: boolean;
  titleText?: string;
  descriptionText?: string | JSX.Element[];
  animate?: boolean;
  onYes?: SelectionOption;
  onNo?: SelectionOption;
  children?: ComponentChildren;
};

function addSelectionOption(selectionOption: SelectionOption, textButtonStyle: Record<string, unknown>) {
  return (
    <Fragment>
      {selectionOption.text ? (
        <TextButton {...textButtonStyle} onClick={selectionOption.onClicked}>
          {selectionOption.text}
        </TextButton>
      ) : null}
      {selectionOption.image ? (
        <ImageButton onClick={selectionOption.onClicked} source={selectionOption.image} />
      ) : null}
      {selectionOption.button ? selectionOption.button : null}
    </Fragment>
  );
}

export const Modal = (props: ModalProps) => {
  return (
    <Fragment>
      {props.shown ? (
        <Fragment>
          <div className="modalBackground" onMouseDown={disableInput} onTouchStart={disableInput} />
          <div className="modalBoxContainer supportsRtl">
            <Box
              className={props.animate ? "modalBox animated" : "modalBox"}
              onMouseDown={disableInput}
              onTouchStart={disableInput}
            >
              {props.titleText ? <div className="modalTitle">{props.titleText}</div> : null}
              {props.descriptionText ? <div className="modalDescription">{props.descriptionText}</div> : null}
              {props.children}
              <div className="modalButtonContainer">
                {props.onYes ? addSelectionOption(props.onYes, { "modal-yes-button": true }) : null}
                {props.onNo ? addSelectionOption(props.onNo, { "modal-no-button": true }) : null}
              </div>
            </Box>
          </div>
        </Fragment>
      ) : null}
    </Fragment>
  );
};
